import CloseIcon from '@mui/icons-material/Close';
import { Dialog, styled, Box as MuiBox, Box } from '@mui/material';
import { BodyMediumRegular } from 'v3/shared/typography/BodyMedium';
import { BodySmallRegular } from 'v3/shared/typography/BodySmall';
import { TitleSmall } from 'v3/shared/typography/TitleSmall';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.primary.main,
    border: `1px solid ${theme.palette.common.white}`,
    borderRadius: '0.375rem',
    width: '100%',
    maxWidth: '37.5rem',
    padding: '1.5rem',
    gap: '2rem',
    flexGrow: 0,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: 'none',
    },
  },
}));

export const Content = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '1.5rem',
  flexGrow: 0,
  overflow: 'hidden',
}));

export const CloseBox = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
}));

export const CloseIconStyled = styled(CloseIcon)(({ theme }) => ({
  cursor: 'pointer',
  color: theme.palette.common.white,
  '&:hover': {
    color: theme.palette.grey[600],
  },
}));

export const Icon = styled('img')(() => ({
  width: '9.5rem',
  marginBottom: '1.5rem',
}));

export const BoxButton = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center'
}));

export const ClientDataBox = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.primary.light,
  borderRadius: '0.375rem',
  gap: '0.25rem',
  width: '19.5rem',
  paddingTop: '0.75rem',
  paddingBottom: '0.75rem',
  paddingLeft: '1rem',
  paddingRight: '1rem',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    maxWidth: 'none',
  },
}));

export const TextOpacity = styled(Box)(() => ({
  opacity: '0.5',
}));